export default "ALTER TABLE `personal_loans` ADD `schedule` text;";